import { createApp, h } from "vue";
import { createInertiaApp, router } from "@inertiajs/vue3";
import axios from 'axios';
import DefaultApp from "./App.vue";
// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VueTheMask from "vue-the-mask";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";

import { plugin as formkitPlugin } from "@formkit/vue";
import formkitConfig from "./formkit.config.js";

import { createPinia } from "pinia";

const vuetify = createVuetify({
    components,
    directives,
    defaults: {
        global: {
            ripple: false,
            elevation: 0,
        },
        VSheet: {
            elevation: 0,
        },
    },
});

const pushState = window.history.pushState;
const replaceState = window.history.replaceState;

if (window.location.protocol === 'https:') {
    window.history.pushState = function(state, unused, url) {
        url = url.replace('http://', 'https://')
        return pushState.call(window.history, state, unused, url);
    };
    window.history.replaceState = function(state, unused, url) {
        url = url.replace('http://', 'https://')
        return replaceState.call(window.history, state, unused, url);
    };
} else {
    window.history.pushState = function(state, unused, url) {
        url = url.replace('https://', 'http://')
        return pushState.call(window.history, state, unused, url);
    };
    window.history.replaceState = function(state, unused, url) {
        url = url.replace('https://', 'http://')
        return replaceState.call(window.history, state, unused, url);
    };
}

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        const orig = router.replaceState;
        router.replaceState = function (page) {
            orig.call(this, JSON.parse(JSON.stringify(page)));
        };

        createApp({ render: () => h(DefaultApp, h(App, props)) })
            .use(vuetify)
            .use(plugin)
            .use(VueTheMask)
            .use(createPinia())
            .use(formkitPlugin, formkitConfig)
            .use(PrimeVue, {
                theme: {
                    preset: Aura,
                },
            })
            .mount(el);
    },
});
